const navData = [
    'index',
    'category', 
    'shopping-car',
    'mine',
  ];
  export default navData;
  
  
  